import { render, staticRenderFns } from "./edit-v2.vue?vue&type=template&id=7c2d72c8&"
import script from "./edit-v2.vue?vue&type=script&lang=js&"
export * from "./edit-v2.vue?vue&type=script&lang=js&"
import style0 from "./edit-v2.vue?vue&type=style&index=0&id=7c2d72c8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports